export default class DashboardService {
  constructor (Api) {
    this.api = Api;
  }

  getWidgetsData () {
    return this.api.get('widgets');
  }
}
